import { useNavigate } from "react-router-dom";
import Button from "./Button";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import "./button.css";

const BackButton = ({ variant = "secondary", size = "md", btncls = "" }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };
  const backbtn = {
    color: "#687594",
  };

  return (
    <Button
      onClick={handleBack}
      variant={variant}
      size={size}
      btncls={`${btncls} bg-transparent d-flex me-4 border-0 mt-0 p-1 mb-3 backbtn`}
      style={backbtn}
      text={<ArrowBackIosNewIcon />}
    />
  );
};

export default BackButton;
